import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Alert } from "../ui/alert";
import {
  Form,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "../ui/form";
import { BusinessUnitService } from "../../services/businessUnitService";

const CreateBusinessUnit = ({ onSuccess, organizationId }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [formData, setFormData] = useState({
    name: "",
    organization_id: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Set organization_id when component mounts or organizationId prop changes
  useEffect(() => {
    if (organizationId) {
      setFormData((prev) => ({
        ...prev,
        organization_id: organizationId,
      }));
    }
  }, [organizationId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const result = await BusinessUnitService.createBusinessUnit(
        formData,
        getAccessTokenSilently
      );

      setFormData({
        name: "",
        organization_id: organizationId,
      });
      if (onSuccess) {
        onSuccess(result.businessUnit);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!organizationId) {
    return (
      <div>
        <Alert className="mb-4">
          Organization context is required to create a business unit.
        </Alert>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-lg font-semibold mb-6">Create New Business Unit</h2>
      {error && (
        <Alert variant="destructive" className="mb-4">
          {error}
        </Alert>
      )}
      <Form onSubmit={handleSubmit} className="space-y-4">
        <FormItem>
          <FormLabel>Business Unit Name *</FormLabel>
          <FormControl>
            <Input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter business unit name"
              required
            />
          </FormControl>
          <FormDescription>
            Enter a unique name for the business unit
          </FormDescription>
        </FormItem>

        <Button
          type="submit"
          size="sm"
          className="w-full"
          disabled={loading || !formData.name.trim()}
        >
          {loading ? "Creating..." : "Create Business Unit"}
        </Button>
      </Form>
    </div>
  );
};

export default CreateBusinessUnit;
